function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _styled from "styled-components";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children, cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import { Portal } from 'react-portal';
import { Manager, Popper, Reference } from 'react-popper';
import EventListener from '../EventListener';
import { Arrow, PopoverContentWrapper, PopoverTriggerWrapper } from './elements';
import { popoverVariants } from './animation';
/**
 * Popover using popperjs and portal
 *
 * See README, run storybook or see propTypes below for documentation
 */

var _StyledPopoverTriggerWrapper = _styled(PopoverTriggerWrapper).withConfig({
  displayName: "Popover___StyledPopoverTriggerWrapper",
  componentId: "l9dlhe-0"
})(["", ""], function (p) {
  return p._css;
});

var Popover = /*#__PURE__*/function (_PureComponent) {
  _inherits(Popover, _PureComponent);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "popoverContent", null);

    _defineProperty(_assertThisInitialized(_this), "popoverTrigger", null);

    _defineProperty(_assertThisInitialized(_this), "setContentRef", function (node) {
      var contentRef = _this.props.contentRef;
      _this.popoverContent = node;
      contentRef && contentRef(node);
    });

    _defineProperty(_assertThisInitialized(_this), "setTriggerRef", function (node) {
      var triggerRef = _this.props.triggerRef;
      _this.popoverTrigger = node;
      triggerRef && triggerRef(node);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrigger", function () {
      var children = _this.props.children;

      if (children instanceof HTMLElement || typeof children === 'string') {
        return children;
      }

      return cloneElement(Children.only(children), children.props);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      if (event.target && _this.popoverContent && !_this.popoverContent.contains(event.target) && _this.popoverTrigger && !_this.popoverTrigger.contains(event.target)) {
        var onClickOutside = _this.props.onClickOutside;
        onClickOutside && onClickOutside(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props = _this.props,
          animationVariants = _this$props.animationVariants,
          content = _this$props.content,
          contentWrapperStyle = _this$props.contentWrapperStyle,
          hasArrow = _this$props.hasArrow,
          isOpen = _this$props.isOpen,
          modifiers = _this$props.modifiers,
          placement = _this$props.placement,
          portalPosition = _this$props.portalPosition,
          positionFixed = _this$props.positionFixed,
          usePortal = _this$props.usePortal,
          width = _this$props.width;
      var popoverContent;
      var popper = /*#__PURE__*/React.createElement(Popper, {
        modifiers: modifiers,
        placement: placement,
        positionFixed: positionFixed
      }, function (_ref) {
        var arrowProps = _ref.arrowProps,
            outOfBoundaries = _ref.outOfBoundaries,
            placement = _ref.placement,
            popperRef = _ref.ref,
            style = _ref.style;
        return /*#__PURE__*/React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/React.createElement(PopoverContentWrapper, {
          key: "popover",
          "data-testid": "popover",
          initial: "hidden",
          animate: "visible",
          exit: "hidden",
          variants: animationVariants,
          "data-out-of-boundaries": outOfBoundaries || undefined,
          "data-placement": placement,
          ref: function ref(node) {
            _this.setContentRef(node);

            popperRef(node);
          },
          style: _objectSpread(_objectSpread({}, style), contentWrapperStyle),
          width: width
        }, content, hasArrow && placement && /*#__PURE__*/React.createElement(Arrow, _extends({
          placement: placement
        }, arrowProps), "\u25B2")));
      });

      if (usePortal) {
        if (portalPosition) {
          var left = portalPosition.left,
              top = portalPosition.top;
          popoverContent = /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
            "data-testid": "positioned-portal",
            style: {
              position: 'absolute',
              left: "".concat(left, "px"),
              top: "".concat(top, "px")
            }
          }, popper));
        } else {
          popoverContent = /*#__PURE__*/React.createElement(Portal, null, popper);
        }
      } else {
        popoverContent = popper;
      }

      return popoverContent;
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          triggerWrapperCss = _this$props2.triggerWrapperCss;
      return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref2) {
        var popperRef = _ref2.ref;
        return /*#__PURE__*/React.createElement(_StyledPopoverTriggerWrapper, {
          ref: function ref(node) {
            if (node !== null) {
              _this2.setTriggerRef(node);

              popperRef(node);
            }
          },
          _css: triggerWrapperCss
        }, _this2.renderTrigger());
      }), this.renderContent(), isOpen && /*#__PURE__*/React.createElement(EventListener, {
        listeners: [{
          target: 'document',
          event: 'click',
          handler: this.handleDocumentClick,
          options: true
        }]
      }));
    }
  }]);

  return Popover;
}(PureComponent);
/**
 * PropTypes Validation
 */


var array = PropTypes.array,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    object = PropTypes.object,
    oneOfType = PropTypes.oneOfType,
    string = PropTypes.string;
Popover.propTypes = {
  /**
   * Custom variants animation from framer motion (https://www.framer.com/api/motion/) options to pass to our popover
   */
  animationVariants: object,

  /**
   * Must be a single element that will be the trigger of the popover
   */
  children: node.isRequired,

  /**
   * Displayed in a portal according to `isOpen` value
   */
  content: oneOfType([string, node]).isRequired,

  /**
   * Callback ref of content element
   */
  contentRef: func,

  /**
   * Custom style for content wrapper
   */
  contentWrapperStyle: object,

  /**
   * If popover content should display with an arrow or not
   */
  hasArrow: bool,

  /**
   * Boolean set to display or hide the popover
   */
  isOpen: bool,

  /**
   * Popper option. Plugins to alter the behaviour of the popper. See https://popper.js.org/popper-documentation.html
   */
  modifiers: object,

  /**
   * Pass this prop on click outside event (for example close the popover by updating `isOpen` prop value)
   */
  onClickOutside: func,

  /**
   * Popper option. Placement applied to popper. See https://popper.js.org/popper-documentation.html
   */
  placement: string,

  /**
   * Custom portal position
   */
  portalPosition: object,

  /**
   * Popper option. Put the popper in "fixed" mode. See https://popper.js.org/popper-documentation.html
   */
  positionFixed: bool,

  /**
   * Display the content on a portal
   */
  usePortal: bool,

  /**
   * Callback ref of trigger element
   */
  triggerRef: func,

  /**
   * css provided to the trigger wrapper. Must use `css` method from styled-components.
   */
  triggerWrapperCss: array,

  /**
   * Popover width
   */
  width: string
};
/**
 * Default props
 */

Popover.defaultProps = {
  animationVariants: popoverVariants,
  contentWrapperStyle: null,
  contentRef: null,
  hasArrow: false,
  isOpen: false,
  modifiers: {},
  onClickOutside: null,
  placement: 'bottom',
  portalPosition: null,
  positionFixed: false,
  triggerRef: null,
  triggerWrapperCss: null,
  usePortal: false,
  width: 'auto'
};
export default Popover;